import { useEffect, useRef } from 'react'

const KAKAO_SDK_URL = 'https://developers.kakao.com/sdk/js/kakao.min.js'
const KAKAO_KEY = import.meta.env.VITE_KAKAO_KEY

interface KakaoLoginButtonProps {
  onToken: (token: string) => void
}

export function KakaoLoginButton({ onToken }: KakaoLoginButtonProps) {
  const sdkLoadedRef = useRef(false)

  useEffect(() => {
    if (sdkLoadedRef.current || !KAKAO_KEY) return

    if (window.Kakao?.isInitialized?.()) {
      sdkLoadedRef.current = true
      return
    }

    const script = document.createElement('script')
    script.src = KAKAO_SDK_URL
    script.onload = () => {
      if (window.Kakao && !window.Kakao.isInitialized()) {
        window.Kakao.init(KAKAO_KEY)
      }
      sdkLoadedRef.current = true
    }
    document.head.appendChild(script)
  }, [])

  const handleClick = () => {
    if (!window.Kakao?.Auth) return

    window.Kakao.Auth.login({
      success: (authObj: { access_token: string }) => {
        onToken(authObj.access_token)
      },
      fail: (err: unknown) => {
        console.error('Kakao login failed:', err)
      },
    })
  }

  if (!KAKAO_KEY) return null

  return (
    <button
      type="button"
      onClick={handleClick}
      className="w-full flex items-center justify-center gap-2 rounded-lg border border-gray-300 bg-[#FEE500] px-4 py-3 text-[#191919] font-medium hover:bg-[#f5dc00] transition-colors"
    >
      카카오 로그인
    </button>
  )
}

declare global {
  interface Window {
    Kakao: {
      init: (key: string) => void
      isInitialized: () => boolean
      Auth: {
        login: (config: {
          success: (authObj: { access_token: string }) => void
          fail: (err: unknown) => void
        }) => void
      }
    }
  }
}
